import PanoramaStarter from './PanoramaStarter';
import Row from "reactstrap/src/Row";
import Col from "reactstrap/src/Col";
import Container from "reactstrap/src/Container";

let webglSupported = null;

const Panorama = ({children, ...props}) => {
    if(webglSupported === null) {
    	try {
			const canvas = document.createElement( 'canvas' );
			webglSupported = !! ( window.WebGLRenderingContext && ( canvas.getContext( 'webgl' ) || canvas.getContext( 'experimental-webgl' ) ) );
		} catch ( e ) {
			webglSupported = false;
		}
	}

	if(webglSupported) {
		return (
            <PanoramaStarter {...props} />
        );
	} else {
        return (

			<div className="webgl-warning">
				<Container>
					<Row>
						<Col className="warning-text">
							Ihr Browser unterstützt kein WebGL oder hat diese Funktion nicht aktiviert. Die Panorama-Ansicht kann deshalb leider nicht genutzt werden.
						</Col>
					</Row>
				</Container>
			</div>


		);
	}

};

export default Panorama;


// WEBPACK FOOTER //
// ./components/Panorama/index.jsx